import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon } from 'lucide-react';
const Header22 = () => {
  return <header className="bg-white" data-id="element-1324">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-1325"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-1326">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-1327">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-1328">
            MEDPRESS GAZETTE
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-1329">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-1330">
          <div className="text-left" data-id="element-1331">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-1332">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-1333">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header - CUSTOM FOR ADV-2-2 */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-1334">
        <div className="max-w-4xl mx-auto" data-id="element-1335">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-1336">
            PERSONAL HEALTH JOURNEY
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-1337">
            My Brother Was Skeptical About Hair Growth Caps. Then He Tried This.
          </h1>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-1338">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-1339">
              <img src="https://cdn.magicpatterns.com/uploads/pgHF1VNF6Whvw8QDg83TjW/31.png" alt="Margaret Weiss" className="w-full h-full object-cover" data-id="element-1340" />
            </div>
            <div className="flex-1" data-id="element-1341">
              <div className="flex items-center" data-id="element-1342">
                <div className="font-medium text-gray-900 text-lg" data-id="element-1343">
                  By Margaret Weiss, RN, MSN
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-1344">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-1345" />
                  <span className="text-xs ml-1 font-medium" data-id="element-1346">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-1347">
                Nurse Practitioner & Medical Device Specialist
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-1348">
                <div className="flex items-center mr-4" data-id="element-1349">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-1350" />
                  <span data-id="element-1351">5 min read</span>
                </div>
                <div className="flex items-center" data-id="element-1352">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-1353" />
                  <span data-id="element-1354">18,234 views</span>
                </div>
              </div>
            </div>
          </div>

          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-1355">
            He called it "magic hat nonsense." I called it science. Six months
            later, we were both looking at a full head of hair that shouldn't
            have been there.
          </p>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-1356">
            <div className="mb-1 flex items-center" data-id="element-1357">
              <span className="font-medium mr-2" data-id="element-1358">Published by:</span>
              MedPress Gazette Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-1359">
              <span className="font-medium mr-2" data-id="element-1360">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>

      {/* Author image */}
      <div className="px-4 sm:px-8 py-6 border-b border-gray-200" data-id="element-1361">
        <div className="max-w-4xl mx-auto" data-id="element-1362">
          <div className="sm:flex items-center" data-id="element-1363">
            <div className="sm:w-1/3 mb-4 sm:mb-0 sm:mr-6" data-id="element-1364">
              <img src="https://cdn.magicpatterns.com/uploads/pgHF1VNF6Whvw8QDg83TjW/31.png" alt="Margaret Weiss, RN, MSN" className="w-full rounded-lg shadow-md" data-id="element-1365" />
            </div>
            <div className="sm:w-2/3" data-id="element-1366">
              <p className="text-sm text-gray-700 mb-2" data-id="element-1367">
                <span className="font-bold" data-id="element-1368">Margaret Weiss, RN, MSN</span> is a
                Nurse Practitioner with 30 years of experience in medical device
                evaluation and patient care. She specializes in separating
                evidence-based treatments from wellness trends.
              </p>
              <p className="text-sm text-gray-700" data-id="element-1369">
                Her work focuses on helping patients make informed decisions
                about health products through rigorous testing and real-world
                results.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default Header22;